import React, { useState } from 'react';
import { buildSpeakUpFlyers } from '../../lib/speakupFlyer';
import { printPdfBlob, downloadPdfBlob } from '../../utils/printLabel';
import { speakUpOrigin } from '../../lib/speakupHost';
import { branchNameById } from './speakupConstants';

// ---------------------------------------------------------------------------
// #479, Speak Up OOB-6. The wall flyers, as one component rendered on TWO
// surfaces — and the second surface is the interesting part.
//
// The defect was that printing lived inside the handler's inbox, which #472
// had narrowed to the assigned handler alone. That narrowing was right; the
// control simply inherited a rule written for reading anonymous reports.
// Colby found it by being unable to follow his own session close's
// instruction: "i cant scan a printed flyer. I'm not the speak up admin."
//
// THE OBVIOUS FIX WAS WRONG IN A WAY THAT ONLY SHOWED UP ON THE SCREEN.
// Moving the block to the oversight page fixes Colby and BREAKS ANGIE. The
// user menu hides the oversight entry from whoever already holds the handler
// entry — deliberately, so one person never sees two doors into the same
// module — and Angie is the handler. She would have been left as the only
// person in the company who could not print the posters for the programme
// she runs, which is the exact shape of the bug being fixed, pointed at a
// different person.
//
// So it renders in both places, from one file. Locked rule 14: the shared
// thing is the side-effect sequence — build, then either print or save — and
// that is what is extracted. Neither page owns it.
//
// WHICH BRANCHES: decided by the caller, not here. A branch manager gets their
// own site; an admin, an executive and the handler get all four. Passing null
// means all four, which is what buildSpeakUpFlyers already does.
//
// A flyer is a public web address, a QR code, the D&R mark and a branch name.
// It discloses nothing a wall in a shop does not disclose by holding it —
// gate decision D8 says assigning is not reading, and the inverse needs
// saying just as plainly: printing a poster is not reading reports.
// ---------------------------------------------------------------------------
export default function SpeakUpFlyerCard({ branchIds = null }) {
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');

  const single = branchIds && branchIds.length === 1;

  async function make(mode) {
    setBusy(mode);
    setError('');
    try {
      const blob = await buildSpeakUpFlyers(branchIds);
      if (!blob) { setError('No flyer to produce for that branch.'); return; }
      const name = single ? 'speak-up-flyer.pdf' : 'speak-up-flyers.pdf';
      // Two destinations, deliberately two buttons. The print dialog is right
      // for a printer on the desk and useless for sending the sheet to a print
      // shop or emailing it to a branch — Colby asked for both.
      const ok = mode === 'print' ? printPdfBlob(blob, name) : downloadPdfBlob(blob, name);
      if (!ok) setError('Your browser blocked that. Try the other button.');
    } catch (e) {
      setError('Could not build the flyer. Try again.');
    } finally {
      setBusy('');
    }
  }

  return (
    <div className="card" style={{ marginBottom: 12 }}>
      <div className="card-body">
        <div className="speakup-flyer-title">Wall flyers</div>
        <div className="speakup-flyer-actions">
          <button className="btn btn-sm" type="button" onClick={() => make('print')} disabled={!!busy}>
            {busy === 'print' ? 'Preparing…' : 'Print'}
          </button>
          <button className="btn btn-sm" type="button" onClick={() => make('download')} disabled={!!busy}>
            {busy === 'download' ? 'Preparing…' : 'Download PDF'}
          </button>
        </div>
        <div className="speakup-flyer-note">
          {single
            ? `One sheet for ${branchNameById(branchIds[0])}`
            : 'One sheet per branch, all four'}
          , with a QR code pointing at <strong>{speakUpOrigin().replace(/^https?:\/\//, '')}</strong>
        </div>
        {error && <div className="speakup-error" style={{ marginTop: 8 }}>{error}</div>}
      </div>
    </div>
  );
}
